import SEOHead from "../components/SEOHead";
import Breadcrumbs from "../components/Breadcrumbs";

export default function PrivacyPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Politique de confidentialité | MarocPratique",
    url: "https://marocpratique.com/politique-confidentialite",
  };

  return (
    <>
      <SEOHead
        title="Politique de confidentialité | MarocPratique"
        description="Politique de confidentialité de MarocPratique.com : données collectées, cookies, droits des utilisateurs."
        canonical="https://marocpratique.com/politique-confidentialite"
        jsonLd={jsonLd}
      />
      <div data-testid="privacy-page" className="max-w-3xl mx-auto px-4 py-10">
        <Breadcrumbs
          items={[
            { label: "Accueil", href: "/" },
            { label: "Politique de confidentialité" },
          ]}
        />
        <article className="prose prose-slate max-w-none mt-6">
          <h1 className="font-heading text-3xl font-bold text-slate-900 mb-6">
            Politique de confidentialité
          </h1>

          <p className="text-slate-500 text-sm mb-8">Dernière mise à jour : Avril 2026</p>

          <h2>1. Présentation du site</h2>
          <p>
            MarocPratique.com est un site d'information pratique destiné aux internautes marocains.
            Il est exploité à titre personnel et ne collecte aucune donnée personnelle sans le
            consentement explicite de l'utilisateur.
          </p>

          <h2>2. Données collectées</h2>
          <p>
            MarocPratique.com ne collecte <strong>aucune donnée personnelle</strong> directement
            (pas de formulaire d'inscription, pas de compte utilisateur). Les seules données
            collectées automatiquement sont des données anonymes via :
          </p>
          <ul>
            <li>
              <strong>Google Analytics</strong> (si activé) : pages vues, durée de session, pays
              d'origine — données agrégées et anonymisées.
            </li>
            <li>
              <strong>Google AdSense</strong> (si activé) : cookies de ciblage publicitaire. Vous
              pouvez refuser ces cookies depuis les paramètres de votre navigateur ou via le
              gestionnaire de consentement Google.
            </li>
            <li>
              <strong>Logs serveur</strong> : adresse IP, navigateur, système d'exploitation —
              conservés 30 jours pour des raisons de sécurité.
            </li>
          </ul>

          <h2>3. Cookies</h2>
          <p>
            Ce site peut utiliser des cookies tiers (Google AdSense, Google Analytics) pour
            mesurer l'audience et afficher des publicités pertinentes. Ces cookies sont gérés par
            Google conformément à sa propre politique de confidentialité (policies.google.com).
          </p>
          <p>
            Vous pouvez refuser les cookies dans les paramètres de votre navigateur. Cela n'affecte
            pas votre accès au contenu du site.
          </p>

          <h2>4. Publicité (Google AdSense)</h2>
          <p>
            MarocPratique.com utilise Google AdSense pour afficher des publicités. Google peut
            utiliser des cookies pour diffuser des annonces basées sur vos visites précédentes sur
            ce site ou d'autres sites. Vous pouvez vous désinscrire de la publicité personnalisée
            sur{" "}
            <a
              href="https://www.google.com/settings/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.google.com/settings/ads
            </a>
            .
          </p>

          <h2>5. Liens externes</h2>
          <p>
            Ce site peut contenir des liens vers des sites externes (administrations officielles,
            organismes publics). MarocPratique.com n'est pas responsable du contenu ni des
            politiques de confidentialité de ces sites tiers.
          </p>

          <h2>6. Droits des utilisateurs</h2>
          <p>
            Conformément à la loi 09-08 relative à la protection des personnes physiques à l'égard
            du traitement des données à caractère personnel, vous disposez d'un droit d'accès, de
            rectification et de suppression de vos données. Pour exercer ces droits, contactez-nous
            via la page{" "}
            <a href="/contact">Contact</a>.
          </p>

          <h2>7. Modifications</h2>
          <p>
            Cette politique peut être mise à jour. La date de dernière modification est indiquée
            en haut de cette page. Votre utilisation continue du site après modification vaut
            acceptation.
          </p>
        </article>
      </div>
    </>
  );
}
